import { communicationsListPath } from "notifications/_views/communications-list-chips";
import { LoaderFunctionArgs, redirect } from "react-router";

/**
 * `/communications`, and every route under it. A list URL from before #6719 -- `/communications/inbox`,
 * `outbox`, `archive` or `forums` -- is sent to the tab and chips it became, keeping the link's other
 * parameters. A route that goes further, a compose dialog or a conversation, keeps resolving, under the
 * retired segments as under the new ones, and the page opens it.
 */
export default function communicationsLoader(args: LoaderFunctionArgs) {
  const { params } = args;
  if (params.action !== undefined) return params;

  const path = communicationsListPath(params.pageTab, new URL(args.request.url).searchParams);
  if (path) return redirect(path);
  return params;
}
